import React from "react";
import { Box, IconButton, Icon, Flex, Text } from "@chakra-ui/react";
import { BsFillFileEarmarkPostFill, BsX } from "react-icons/bs";
import { GroupItemProps } from "./Group.types";

export function GroupItem({ group, onDelete, onClick, onClose }: GroupItemProps) {  
  function handleItemClick(id: string) {
    onClick(id);
    onClose();
  }
    return (
      <Box
        display="flex"
        paddingX="1rem"
        cursor="pointer"
        paddingY="0.4rem"
        alignItems="center"
        _hover={{ bg: "gray.100" }}
        justifyContent="space-between"
        onClick={() => handleItemClick(group.id)}
      >
        <Flex alignItems="center" flex={1}>
          <Icon as={BsFillFileEarmarkPostFill} size="sm" color="#747AA5" />
          <Text fontSize="12px" marginLeft="0.5rem" color="#212242">
            {group.name}
          </Text>
        </Flex>
        <IconButton
          size="md"
          icon={<BsX />}
          aria-label='close-icon'
          variant="ghost"
          onClick={() => onDelete && onDelete()}
        />
      </Box>
    );
  }